export class LoginResponse {
    Success: boolean;
    Error: string;
    loginResult: any;
}